import {
  AcceptType, ContentType, getRequest, postRequest,
} from '@utils/apiUtils';

export const getCommentTemplateList = () => {
  return getRequest<comment.CommentTemplateData[]>('/p2p-admin/comment-templates');
};

export const postUpdateCommentTemplate = (payload: comment.UpdateCommentTemplatePayload) => {
  return postRequest('/p2p-admin/comment-templates/update', payload);
};

export const downloadMultipleCommentsTemplate = () => {
  return getRequest<BlobPart>('/p2p-admin/comment-templates/multiple-comments/download', {}, {
    responseType: 'blob',
    acceptType: AcceptType.JSON,
    contentType: ContentType.JSON,
  });
};

export const uploadMultipleCommentsExcel = (param: FormData) => {
  return postRequest<comment.MultipleCommentsExcelData>('/p2p-admin/comment-templates/multiple-comments/upload', param);
};
